import BaseService from "./BaseService";

class BrazeService extends BaseService {
  constructor() {
    super({ configPath: 'services.braze' });
  }

  async getUsers(email) {
    try{
      const config = await this.config()

      let requestHeaders = {
        'Authorization': `Bearer ${config.apiKeyExportIds}`
      }

      let requestBody = {
        email_address: email,
        fields_to_export: ["email", "phone", "user_aliases", "external_id"]
      }

      return await  this.requestResource('userEvent', {
        tokenType: 'none',
        method: 'POST',
        params: {eventType: 'export/ids'},
        headers: requestHeaders,
        data: requestBody,
        redirect: 'follow'
      })

    } catch(error) {
      console.log(error)
      return error.response
    }
  }

  async createAliasAccount(userAliases) {
    try {
      const config = await this.config();
  
      let requestHeaders = {
        'Authorization': `Bearer ${config.apiKeyCreateAlias}`
      }

      let requestBody = {
        user_aliases: userAliases
      }

      return await  this.requestResource('userEvent', {
        tokenType: 'none',
        params: {eventType: 'alias/new'},
        method: 'POST',
        headers: requestHeaders,
        data: requestBody,
        redirect: 'follow'
      })

    } catch(error) {
      console.log(error)
      return error.response
    }
  }

  async trackUserEvent(user, alias, date) {
      try {
        const config = await this.config();

        let requestHeaders = {
          'Authorization': `Bearer ${config.apiKeyTrackUser}`
        }

        let requestBody = {
          attributes: [
            {
                external_id: user.external_id,
                email: user.email,
                user_alias: alias,
                source: 'react',
                source_type: 'newsletter',
            },
        ],
        events: [
            {
                external_id: user.external_id,
                user_alias: alias,
                app_id: config.appId,
                name: 'newsletter_signup',
                time: date,
            },
          ],
        }

        return await  this.requestResource('userEvent', {
          tokenType: 'none',
          params: {eventType: 'track?='},
          method: 'POST',
          headers: requestHeaders,
          data: requestBody,
          redirect: 'follow'
        })
        
      } catch(error){
        console.log(error)
        return error.response
      }
    }
}

export default BrazeService
